var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"tree-dots"},_vm.$listeners),[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }